import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

export const equipmentTypesKey = (equipmentType) => ['equipmentTypes', equipmentType];
export const equipmentTypesFn = ({ queryKey }) =>
  apiClient.get(`${APP_API_URL}equipment/equipment-types`, {
    params: { add_equipment_type: queryKey[1] },
  });

export const useEquipmentTypesQuery = ({ equipmentType }) => {
  return useQuery({
    queryKey: equipmentTypesKey(equipmentType),
    queryFn: equipmentTypesFn,
    enabled: !!equipmentType,
    select: ({ data }) => data?.data,
  });
};
